/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import PageHeader from '../../components/PageHeader';
import Memberships from '../../components/Membership/Memberships';
import { useHistory } from 'react-router-dom';
import queryString from "query-string";
import MembershipHistories from '../../components/Membership/MembershipHistories';
import MembershipTaxDetails from '../../components/Membership/MembershipTaxDetails';

const Membership = () => {
  const history = useHistory();
  const [activeTab, setActiveTab] = useState("membership");

  const { user } = useSelector(
    (store) => ({
      user: store.Profile.user,
    }),
    shallowEqual
  );

  const _setActiveTab = (value) => {
    history.push(`/admin/membership?tab=${value}`);
  };
  const tabList = [
    {
      label: (
        <>
          멤버십 등급 관리
        </>
      ),
      action: _setActiveTab,
      value: "membership",
    },
    {
      label: (
        <>
          회사별 멤버십 관리
        </>
      ),
      action: _setActiveTab,
      value: "history",
    },
    {
      label: (
        <>
          세무회사별 멤버십 관리
        </>
      ),
      action: _setActiveTab,
      value: "tax-detail",
    },
  ];

  useEffect(() => {
    const query = queryString.parse(history.location.search);
    setActiveTab(query.tab || tabList[0].value);
  }, [history.location]);


  return (
    <>
      <PageHeader
        title={`안녕하세요, ${user && user.name}님.`}
        activeTab={activeTab}
        tabList={tabList}
      />
      {activeTab === "membership" && <Memberships />}
      {activeTab === "history" && <MembershipHistories />}
      {activeTab === "tax-detail" && <MembershipTaxDetails />}
    </>
  );
};

export default Membership;